import React from 'react';
import { LockIcon } from 'lucide-react';
import { AgentMark } from '../../ui/AgentMark';
import { agents } from '../../../data/agents';
import { capabilities } from '../../../data/beheer/permissions';
import { PERMISSION_CYCLE as CYCLE, PERMISSION_META } from '../../../data/beheer/permissionMeta';
import type { CapabilityId, Permission, PermissionMatrix as Matrix } from '../../../types/settings';
import type { AgentId } from '../../../types/anna';
interface PermissionMatrixProps {
  matrix: Matrix;
  onChange: (agent: AgentId, cap: CapabilityId, next: Permission) => void;
}

/** Who may do what, and at which level. Tap a cell to step through the levels; fixed rules are locked. */
export function PermissionMatrix({
  matrix,
  onChange
}: PermissionMatrixProps) {
  return <div className="no-scrollbar overflow-x-auto rounded-3xl border border-white/[0.07] bg-night-900" data-id="element-50" data-mp="1k2gb3u0sd80t">
      <table className="w-full min-w-[1080px] text-left text-[13px]" data-id="element-51" data-mp="1osmyjqjkamhh">
        <thead data-id="element-52" data-mp="1ouzk0doj3eza">
          <tr className="border-b border-white/[0.06]" data-id="element-53" data-mp="1rwcz7mn3iltu">
            <th scope="col" className="sticky left-0 z-10 bg-night-900 px-5 py-3 text-[12px] font-medium text-ink-muted" data-id="element-54" data-mp="1rwv0ixom7q8m">
              Agent
            </th>
            {capabilities.map(c => <th key={c.id} scope="col" className="px-2 py-3 align-bottom" title={c.hint} data-id="element-55" data-mp="20q82sq8kk47d">
                <span className={`flex items-center gap-1 whitespace-nowrap text-[12px] font-medium ${c.locked ? 'text-ink-muted' : 'text-ink-soft'}`} data-id="element-56" data-mp="1vwdmzxw349dk">
                  {c.locked && <LockIcon className="h-3 w-3" aria-hidden data-id="element-57" data-mp="25o9n1ehqe9kf" />}
                  {c.label}
                </span>
              </th>)}
          </tr>
        </thead>
        <tbody className="divide-y divide-white/[0.05]" data-id="element-58" data-mp="2flxt30ksf3hw">
          {agents.map(a => <tr key={a.id} data-id="element-59" data-mp="2fk38xohcbfev">
              <th scope="row" className="sticky left-0 z-10 bg-night-900 px-5 py-2.5 font-normal" data-id="element-60" data-mp="p8ymudonfuat">
                <span className="flex items-center gap-2.5 whitespace-nowrap text-[14px] text-ink" data-id="element-61" data-mp="l8enr4kimgm1">
                  <AgentMark agentId={a.id} size="sm" data-id="element-62" data-mp="2kd6btaullnfn" /> {a.name}
                </span>
              </th>
              {capabilities.map(c => {
            const value = matrix[a.id][c.id];
            const meta = PERMISSION_META[value];
            const Icon = meta.icon;
            const next = CYCLE[(CYCLE.indexOf(value) + 1) % CYCLE.length];
            return <td key={c.id} className="px-2 py-2.5" data-id="element-63" data-mp="33c294v1r6hxp">
                    <button type="button" disabled={c.locked} onClick={() => onChange(a.id, c.id, next)} aria-label={`${a.name}, ${c.label}: ${meta.short}${c.locked ? ', vaste regel' : `. Wijzig naar ${PERMISSION_META[next].short}`}`} className={`inline-flex h-7 items-center gap-1.5 whitespace-nowrap rounded-full px-2.5 text-[12px] font-semibold transition-colors duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/60 disabled:cursor-not-allowed ${meta.className} ${c.locked ? '' : 'hover:ring-1 hover:ring-white/25'}`} data-id="element-64" data-mp="339fz8ore3qcb">
                      <Icon className="h-3 w-3" strokeWidth={2} aria-hidden data-id="element-65" data-mp="16cjrn7mlvcb6" />
                      {meta.short}
                    </button>
                  </td>;
          })}
            </tr>)}
        </tbody>
      </table>
    </div>;
}